import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import Sidebar from '../components/Sidebar';
import Navigation from '../components/Navigation';
import { FaFileUpload } from "react-icons/fa";
import { PDFDocument } from 'pdf-lib';
import mammoth from 'mammoth';
import base_url from '../config/Config';
import { NavLink, useLocation } from 'react-router-dom';
import axios from 'axios';

const Document = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [documentName, setDocumentName] = useState('');
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
    const fileInputRef = useRef(null);

    const handleClose = () => setShow(false);
    const handleShow = (name) => {
        setDocumentName(name);
        setShow(true);
        setPdfPreviewUrl(null); // Reset pdfPreviewUrl when opening modal
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            setIsLoading(true);
            const pdfFile = await convertToPDF(file); // Convert the uploaded file to PDF
            setPdfPreviewUrl(URL.createObjectURL(pdfFile));
            await uploadFile(pdfFile);
            setIsLoading(false);
        }
    };

    const convertToPDF = async (file) => {
        const pdfDoc = await PDFDocument.create();
        const page = pdfDoc.addPage();
        const { width, height } = page.getSize();
        const arrayBuffer = await file.arrayBuffer();

        if (file.type === 'image/jpeg' || file.type === 'image/jpg') {
            const embeddedFile = await pdfDoc.embedJpg(arrayBuffer);
            const scaledDims = embeddedFile.scaleToFit(width, height);
            page.drawImage(embeddedFile, {
                x: (width - scaledDims.width) / 2,
                y: (height - scaledDims.height) / 2,
                width: scaledDims.width,
                height: scaledDims.height,
            });
        } else if (file.type === 'image/png') {
            const embeddedFile = await pdfDoc.embedPng(arrayBuffer);
            const scaledDims = embeddedFile.scaleToFit(width, height);
            page.drawImage(embeddedFile, {
                x: (width - scaledDims.width) / 2,
                y: (height - scaledDims.height) / 2,
                width: scaledDims.width,
                height: scaledDims.height,
            });
        } else if (file.type === 'application/pdf') {
            const existingPdfBytes = await file.arrayBuffer();
            const existingPdfDoc = await PDFDocument.load(existingPdfBytes);
            const [existingPage] = await pdfDoc.copyPages(existingPdfDoc, [0]);
            pdfDoc.addPage(existingPage);
        } else if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            const { value: docText } = await mammoth.extractRawText({ arrayBuffer });
            page.drawText(docText, { x: 50, y: height - 50, size: 12 });
        } else if (file.type === 'image/webp') {
            const pngBlob = await convertWebPToPNG(arrayBuffer);
            const pngArrayBuffer = await pngBlob.arrayBuffer();
            const embeddedFile = await pdfDoc.embedPng(pngArrayBuffer);
            const scaledDims = embeddedFile.scaleToFit(width, height);
            page.drawImage(embeddedFile, {
                x: (width - scaledDims.width) / 2,
                y: (height - scaledDims.height) / 2,
                width: scaledDims.width,
                height: scaledDims.height,
            });
        } else {
            throw new Error('Unsupported file type');
        }

        const pdfBytes = await pdfDoc.save();
        const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
        return new File([pdfBlob], file.name.replace(/\.[^/.]+$/, ".pdf"), { type: 'application/pdf' });
    };

    const uploadFile = async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch('/api/upload', {
                method: 'POST',
                body: formData,
            });
            if (response.ok) {
                const uploadedFile = await response.json();
                setUploadedFiles(prevUploadedFiles => [...prevUploadedFiles, uploadedFile]);
                console.log('File uploaded successfully');
            } else {
                console.error('File upload failed');
            }
        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };

    const handleIconClick = () => {
        fileInputRef.current.click();
    };

    useEffect(() => {
        const fetchUploadedFiles = async () => {
            try {
                const response = await fetch('/api/files');
                const files = await response.json();
                setUploadedFiles(files);
            } catch (error) {
                console.error('Error fetching uploaded files:', error);
            }
        };

        fetchUploadedFiles();
    }, []);
    
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };

    const queryParams = useQuery();
    const id = queryParams.get('id');

    useEffect(() => {
        const getOneCustomer = async () => {
            try {
                const response = await axios.get(`${base_url}/api1/customer/customerListById`, { params: { id } });
                console.log(response.data);
            } catch (error) {
                console.error("Error fetching Customer data:", error);
            }
        };

        if (id) {
            getOneCustomer();
        }
    }, [id]);

    return (
        <>
            <div className='overviewsaa'>
                <h4>Customer Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10 col-sm-10 col-12'>
                        <div className='personalhead text-justify mt-4'>
                            <p>Document Details</p>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 col-lg-12'>
                                    <div className='reportsanalyzier mb-3 text-center'>
                                        <div className='row'>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='credit buttonandly'>
                                                    {/* <span onClick={cibilReportPDF}><p>Credit Report</p></span> */}
                                                    <NavLink to={`/headerfile/CreditReport?id=${id}`}><p>Credit Report</p></NavLink>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='analyzier buttonandly'>
                                                    <NavLink to={`/headerfile/LoanAgreement?id=${id}`}><p>Loan Agreement</p></NavLink>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='digitalfoot buttonandly'>
                                                    <NavLink to={`/headerfile/Document?id=${id}`}><p>Document</p></NavLink>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='devicehistory buttonandly'>
                                                    <NavLink to={`/loanmaster/ViewLoanMaster?id=${id}`}> <p>Loan Details</p></NavLink>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='location buttonandly'>
                                                    <NavLink to={`/operation/ViewVerifiedCustomer?id=${id}`}><p>Customer View</p></NavLink>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='businessverification buttonandly'>
                                                    <NavLink to={`/headerfile/NOC?id=${id}`}><p>NOC</p></NavLink>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                </div>
                                </div>
                        <div className='documnetsection mt-3 mb-3'>
                            <div className='row'>
                                {['Selfie', 'Aaddhar Card Front', 'Aadhar card Back', 'Pan Card', 'Bank Passbook', 'Cheque', 'Salary Slip', 'Bank Statement', 'Co-Selfie', 'Co-Aadhar Card Front', 'Co-Aadhar Crad Back', 'Business Gst Certificate', 'Business Address Proof', 'Credit Score', 'Business Pan Card', 'Udyam registration certificate'].map((label, index) => (
                                    <div key={index} className='col-lg-3 col-md-3 col-sm-3 col-12 mt-3'>
                                        <div className='profileimage documnetupload'>
                                            <span>{label}</span> <br />
                                            <FaFileUpload size={20} onClick={() => handleShow(label)} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='uploaded-files'>
                            <ul>
                                {uploadedFiles.map((file, index) => (
                                    <li key={index}>
                                        <a href={file.url} target="_blank" rel="noopener noreferrer">
                                            {file.name}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={show} onHide={handleClose} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Upload {documentName}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="d-flex flex-column" style={{ height: 'auto' }}>
                    <input type="file" className='mb-3' ref={fileInputRef} onChange={handleFileChange} accept="" />
                    <span onClick={handleIconClick} disabled={isLoading}>
                        {isLoading ? (
                            <Spinner animation="border" size="sm" />
                        ) : (
                            <></>
                        )}
                    </span>
                    {pdfPreviewUrl && (
                        <iframe src={pdfPreviewUrl} style={{ flex: 1 }} title="PDF Preview" />
                    )}
                </Modal.Body>
                <div className='text-center mt-1'>
                    <Button variant="primary" disabled={isLoading}>
                        Upload
                    </Button>
                </div>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default Document;

// Function to convert WEBP to PNG (example using canvas)
const convertWebPToPNG = async (arrayBuffer) => {
    const blob = new Blob([arrayBuffer], { type: 'image/webp' });
    const image = new Image();
    image.src = URL.createObjectURL(blob);
    await new Promise((resolve) => {
        image.onload = resolve;
    });

    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext('2d');
    context.drawImage(image, 0, 0);

    return new Promise((resolve) => {
        canvas.toBlob(resolve, 'image/png');
    });
};
